export interface TaxInterviewData {
    accountId: string;
    earnerId: string;
    identityType: string;
    payeeId: string;
    taxInterviewURL: string;
}

export enum TAX_PROFILE_STATUS {
    NULL = 'NULL',
    NAME_MISS_MATCH = 'NameMismatch',
    INVALID_TAX_INFO = 'InvalidTaxInfo',
    MISSING_TAX_INFO = 'MissingTaxInfo',
    DEACTIVATED = 'Deactivated',
    TAX_INFO_REQUIRES_UPDATE = 'TaxInfoRequiresUpdate',
    VALIDATED_TAX_INFO = 'ValidatedTaxInfo',
    TAX_INFO_ON_FILE = 'TaxInfoOnFile',
    VALIDATION_DEFERRED = 'ValidationDeferred',
    TAX_INFO_NOT_REQUIRED = 'TaxInfoNotRequired'
}

export interface TaxProfileState {
    loading: boolean;
    loadingUrl: boolean;
    taxInterviewUrl?: string;
    currentUrl?: string;
    error?: string | null;
    taxProfile?: TaxProfile;
    interviewFailed?: boolean;
    updating?: boolean;
    accountStatus?: string;
    accountStatusLoading?: boolean;
    taxProfileStatus?: string;
    retakeAvailable?: boolean;
    taxDocumentsLoading?: boolean;
    taxDocuments?: TaxDocument[];
    selectedTaxYear?: number;
    yearLength?: number;
    taxDocumentsError?: string;
    emailExisted?: boolean | null;
    checkingEmail?: boolean;
    fetchedTaxProfile?: boolean;
}

enum ProfileType {
    INDIVIDUAL = 'Individual',
    OTHER_ENTITY = 'Other-Entity'
}

export interface TaxProfile {
    identityId: string;
    profileType: ProfileType;
    firstName: string;
    lastName: string;
    legalName: string;
    email: string;
    phoneNumber: string;
    dateOfBirth: string;
    tin: string;
    tinType: string;
    foreignTin: string;
    taxVerified: boolean;
    taxStatus: string;
    taxStatusExpiryDate: Date;
    taxTreatyCountryCode: string;
    addressLine1: string;
    addressLine2: string;
    addressCity: string;
    addressState: string;
    addressCountryCode: string;
    addressPostCode: string;
    mailingAddressDifferent: boolean;
    mailingAddressLine1: string;
    mailingAddressLine2: string;
    mailingAddressCity: string;
    mailingAddressState: string;
    mailingAddressCountryCode: string;
    mailingAddressPostCode: string;
    recordIdentityKey: string;
    recordCreatedOn: string;
    recordModifiedOn: string;
    rvn: number;
    createdAt: string;
    modifiedAt: string;
    payeeId: string;
    usperson: boolean;
    individual: boolean;
    organizationEntity: boolean;
    guardianFirstName?: string;
    guardianLastName?: string;
    guardianEmail?: string;
    guardianPhoneNumber?: string;
}

export interface AccountStatusResponse {
    Status: string;
    data: {
        accountStatus: string;
    };
}

export enum ACCOUNT_STATUS {
    ACCOUNT_NOT_EXIST = 'ACCOUNT_NOT_EXIST',
    ACTIVE = 'ACTIVE',
    VERIFICATION_REQUIRED = 'VERIFICATION_REQUIRED',
    PENDING_ACCOUNT_ACTIVATION = 'ACCOUNT_PENDING_ACTIVATION',
    PENDING_TRANSFER_METHOD_ACTION = 'ACCOUNT_PENDING_TRANSFER_METHOD',
    ACCOUNT_PENDING_VERIFICATION = 'ACCOUNT_PENDING_VERIFICATION'
}

export interface RetakeAvailableResponse {
    Status: string;
    data: {
        available: boolean;
    };
}

export interface TaxDocument {
    documentId: string;
    recordIdentityKey: string;
    payeeId: string;
    taxYear: number;
    documentType: string;
    documentDescription: string;
    originalFieldName: string;
}

export interface TaxDocumentsResponse {
    Status: string;
    data: {
        documents: TaxDocument[];
        yearLength: number;
    };
}

export enum PAYMENT_STATUS {
    COMPLETED = 'Completed',
    IN_PROGRESS = 'InProgress',
    PENDING = 'Pending',
    PAYMENT_NOT_MET = 'PaymentRequirementNotMet'
}

export enum PAYOUT_ACCOUNT_STATUS {
    ACTIVE = 'ACTIVE',
    DRAFT = 'DRAFT'
}

export interface PayoutFormValues {
    gatewayType: string;
    accountEmail?: string;
    foreignBank?: boolean;
    checkName?: string;
    bankName?: string;
    routingNo?: string;
    bankAccountNo?: string;
    swiftCode?: string;
    additionalAccountDetail?: string;
    accountStatus?: PAYOUT_ACCOUNT_STATUS;
}

export interface PayoutState {
    loading: boolean;
    error: string | null;
    form: PayoutFormValues;
    updating: boolean;
}

export const PAYOUT_DEFAULT_STATE: PayoutState = {
    loading: false,
    error: null,
    form: {
        gatewayType: ''
    },
    updating: false
};

export enum GATEWAY_TYPE {
    PAYPAL = 'PAYPAL',
    WIRE_TRANSFER = 'WIRE_TRANSFER'
}
